import store from "./store/store";
import * as types from './store/types'
import axios from 'axios'
let pending = []; //声明一个数组用于存储每个ajax请求的取消函数和ajax标识
let cancelToken = axios.CancelToken;
let removePending = (config) => {
  for(let p in pending){
    if(pending[p].u === config.url + '&' + config.method) { //当当前请求在数组中存在时执行函数体
      pending[p].f(); //执行取消操作
      pending.splice(p, 1); //把这条记录从数组中移除
    }
  }
}
// 需要取消重复请求的数组
const urlArr = [
  '/api/visitor/getCreditCompany',
  '/api/getCreditCompany',
  '/api/creditCompanyDetail',
  '/api/visitor/creditCompanyDetail',
  '/api/socialGraph/detail',
  '/api/socialGraph/relation'
]

function Auth(router, http) {
    this.router = router;
    this.http = http;
    this.http.interceptors.request.use(
        config => {
          if (store.state.token) {
                config.headers.Authorization = `Bearer ${store.state.token}`;
          }
          if (urlArr.indexOf(config.url) !== -1) {
            removePending(config); //在一个ajax发送前执行一下取消操作
            config.cancelToken = new cancelToken((c)=>{
              // 这里的ajax标识我是用请求地址&请求方式拼接的字符串
              pending.push({ u: config.url + '&' + config.method, f: c });
            });
          }
            return config;
        },
        err => {
            return Promise.reject(err);
        });
    this.http.interceptors.response.use(
        response => {
            var headers = response.headers,
                token = headers.Authorization || headers.authorization;
            if (token) {
                token = token.split(/Bearer\:?\s?/i);
                token = token[token.length > 1 ? 1 : 0].trim();
                if (token) {
                    localStorage.token = token;
                }
            }
          if (urlArr.indexOf(response.config.url) !== -1) {
            removePending(response.config);  //在一个ajax响应后再执行一下取消操作，把已经完成的请求从pending中移除
          }
          return response;
        },
        error => {
            if (error.response) {
                 switch (error.response.status) {
                     case 401:
                         store.commit(types.LOGOUT);
                         store.commit(types.LEVEL,'-1');
                         store.commit(types.USER,'');
                         store.commit(types.CHANNEL,'');
                         break;
                     case 500:

                         break;
                 }
            }
            return Promise.reject(error.response.data)
        });
}

Auth.prototype.logout = function (path) {
    (this.router.push || this.router.go).call(this.router, path);
};

export default Auth;



// WEBPACK FOOTER //
// ./src/auth.js